import React, { Fragment, Component } from 'react';
import '../App.css';
import PropTypes from 'prop-types';
import Modal from './Modal';

class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
    this.state = { modal: false };
  }

  handleClick() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    return (
      <Fragment>
        <div
          className={`category-card ${this.props.isSmallCard ? 'category-small-card' : 'category-large-card'} ${this.props.data.hide? 'd-none' : ''}`}
          onClick={this.handleClick}
        >
          <div className="header">
            {this.props.data.category}
          </div>
          <img className="card-image" src={`${process.env.PUBLIC_URL}${this.props.data.winner_image_thumbnail}`} alt="hello" />
          <div className="middle" >
            <div className="text">{this.props.data.winner}</div>
          </div>
        </div>
        {this.state.modal && <Modal onCloseRequest={() => this.handleClick()} data={this.props.data} /> }
      </Fragment>
    );
  }
}


Card.propTypes = {
  isSmallCard: PropTypes.bool.isRequired,
};


export default Card;
